<template>
  <section class="pt-7 px-9 roboto box-mobile homecontainer mx-auto flex text-skin-secondary" 
    v-if="courseShow">
    <div class="product-container">
      <p class="name-product ">
        {{ selected_course.courses.name }}
      </p>
      <br />
      <p class="product-this  text-skin-secondary text-skin-description">
        Curso de {{ selected_course.course_owner.name }}
        {{ selected_course.course_owner.lastname }}
        <span class="product-carrer">
          <span class="slash">/</span>
          {{ selected_course.course_owner.specialty }}</span
        >
      </p>
      <br />
      <div class="raiting-container mt-10 align-items-center">
        <div class="date text-skin-secondary">
          Publicado:
          <span class="text-skin-pink">{{moment(selected_course.date_in).format("DD/MM/YYYY")}}</span>
        </div>
        <div class="interactions flex align-items-center">
          <div class="users flex align-items-center">
            <img src="../assets/usuario.svg" alt="" />
            <span class="number-user">{{
              selected_course.lessons_in_course.users_in_course
            }}</span>
          </div>
          <div class="starts">
            <RatingComponent class="mx-4 raiting-mobile"></RatingComponent>
          </div>
          <div class="tag" align="center">Mas vendido</div>
        </div>
      </div>
      <div class="tabs-component bg-skin-secondary mt-10">
        <div class="cursor-pointer text-skin-description" @click="goToSection(0)">Acerca de</div>
        <div class="cursor-pointer text-skin-description" @click="goToSection(1)">Módulo</div>
        <div class="cursor-pointer text-skin-description" @click="goToSection(2)">Especialista</div>
      </div>
      <div class="about-course mt-10" v-if="showInfo === 0">
        <p class="title-about">Acerca del curso</p>
        <div class="description-about" v-html="selected_course.courses.description">
        </div>
      </div>
      <div class="w-100 buy-mobile" align="center">
        <BuyContainer
          :number_lesson="selected_course.lessons_in_course"
          :item="selected_course"
        ></BuyContainer>
      </div>
      <div
        class="module-component buy-desktop mt-10"
        v-if="showInfo === 1"
        id="module-component"
      >
        <div class="title-about module-border pb-2 text-skin-primary ">
          MODULO
        </div>
        <div v-for="item in selected_course.modules" :key="item.id">
          <ModuleProduct :item="item"></ModuleProduct>
        </div>
      </div>
      <div class="buy-mobile" v-if="showInfo === 1">
        <div class="title-about module-border pb-2 text-skin-primary">
          MODULO
        </div>
        <div v-for="item in selected_course.modules" :key="item.id">
          <ModuleProductMobile :item="item"></ModuleProductMobile>
        </div>
      </div>
      <div
        class="especialist-component mt-12"
        v-if="showInfo === 2"
        id="module-especialist"
      >
        <div class="title-about module-border  text-skin-primary  pb-2 mb-10">
          ESPECIALISTA
        </div>
        <div class="name-specialist text-skin-description">
          {{ selected_course.course_owner.name }}
        </div>
        <span class="product-this product-carrer">
          {{ selected_course.course_owner.specialty }}</span
        >
        <div class="flex pt-10px mt-10 md:py-0 items-center">
          <a target="_blank" :href="selected_course.course_owner.data.email"
            ><Mail class="cursor-pointer h-24px w-24px"
          /></a>
          <a target="_blank" :href="selected_course.course_owner.data.instagram"
            ><Instagram class="mx-25 cursor-pointer h-24px w-24px"
          /></a>
          <a target="_blank" :href="selected_course.course_owner.data.facebook"
            ><Facebook class="cursor-pointer h-24px w-24px"
          /></a>
        </div>
        <div class="info-specialist mt-10 pb-10 text-skin-description leading-10">
          <div v-html="selected_course.course_owner.description">
          </div>
        </div>
      </div>
    </div>
    <BuyContainer
      :number_lesson="selected_course.lessons_in_course"
      class="buy-desktop"
      :item="selected_course"
    ></BuyContainer>
  </section>
</template>

<script>
import RatingComponent from "../../src/components/Rating.vue";
import ModuleProduct from "../../src/components/ModuleProduct.vue";
import ModuleProductMobile from "../../src/components/ModuleProductMobile.vue";
import Mail from "../components/icons/Mail.vue";
import Instagram from "../components/icons/Instagram.vue";
import Facebook from "../components/icons/Facebook.vue";

import BuyContainer from "../components/BuyContainer.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    RatingComponent,
    ModuleProduct,
    Mail,
    Instagram,
    Facebook,
    // CommentsProduct,
    BuyContainer,
    ModuleProductMobile,
  },
  computed: {
    ...mapGetters({
      selected_course: "course/getSelectedCourse",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
    if(Object.keys(this.selected_course).length === 0){
      this.$store
        .dispatch("course/getCoursesDetail", {
          course_id: this.$route.params.id,
          proyect_id: process.env.VUE_APP_PROYECT_ID,
        }).then(() => {
          this.courseShow =true
        });
    }else{
      this.courseShow =true
    }
  },
  data() {
    return {
      showInfo: 0,
      courseShow:false,
    };
  },
  methods: {
    goToSection(value) {
      switch (value) {
        case 0:
          this.showInfo = 0;
          break;
        case 1:
          this.showInfo = 1;
          break;
        case 2:
          this.showInfo = 2;
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style>
.price-course {
  font: normal normal 900 40px/48px Roboto;
  letter-spacing: 0px;
  color: #e76474;
  opacity: 1;
}

.product-container {
  width: 75% !important;
}

.buy-mobile {
  display: none;
}

.go-buy {
  padding-top: 100px;
  padding: 45px;
  text-align: left;
  width: 25% !important;
}

.item {
  font: normal normal normal 16px/22px Roboto;
  letter-spacing: 0px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
}

.usd {
  font: normal normal 900 22px/27px Roboto;
}

.add-cart-button {
  border: 2px solid #e76474;
  border-radius: 19px;
  opacity: 1;
  font: normal normal normal 16px/18px Roboto;
  letter-spacing: 0px;
  color: #e76474;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
}

.add-course-button {
  background: transparent linear-gradient(270deg, #de357a 0%, #f08f6e 100%) 0%
    0% no-repeat padding-box;
  border-radius: 19px;
  opacity: 1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
}

.raiting-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-specialist {
  font: normal normal normal 16px/19px Roboto;

  opacity: 1;
}

.name-specialist {
  font: normal normal normal 40px/48px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}

.module-border {
  border-bottom: 0.5px solid #707070;
}

.title-about {
  font: normal normal medium 18px/22px Roboto;
  letter-spacing: 0px;
  opacity: 1;
  font-weight: 500;
}

.tag {
  background: #6de178 0% 0% no-repeat padding-box;
  opacity: 1;
  color: white;
  font: normal normal normal 11px/22px Roboto;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  width: 103px;
  height: 18px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.number-user {
  text-align: left;
  font: normal normal normal 13px/22px Roboto;
  letter-spacing: 0px;
  color: #848484;
  opacity: 1;
}

.date {
  text-align: left;
  font: normal normal normal 15px/22px Roboto;
  letter-spacing: 0px;
}

.name-product {
  text-align: left;
  font: normal normal medium 40px/48px Roboto;
  font-size: 40px;
  font-weight: 500;
  letter-spacing: 0px;
  opacity: 1;
  width: 529px;
  line-height: 1.3;
}

.product-this {
  text-align: left;
  font: normal normal bold 16px/22px Roboto;
  letter-spacing: 0px;
}

.product-carrer {
  font-weight: 400;
}

.tabs-component {
  display: flex;
  justify-content: space-around;
  height: 40px;
  border-radius: 7px;
  opacity: 1;
  align-items: center;
  font: normal normal normal 15px/11px Roboto;
  letter-spacing: 0px;
  color: #848484;
  opacity: 1;
}

@media (max-width: 1024px) {
  .box-mobile {
    display: flex;
    flex-direction: column;
  }

  .product-carrer {
    display: block;
  }

  .name-product {
    width: 100%;
    border-bottom: 0.5px solid #707070;
    font-size: 20px;
  }

  .slash {
    display: none;
  }

  .raiting-mobile {
    display: none;
  }

  .raiting-container {
    flex-direction: column;
    align-items: flex-start !important;
    margin-top: 10px !important;
  }

  .interactions {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .users {
    margin-top: 10px;
  }

  .tag {
    margin-top: 10px;
  }

  .product-container {
    width: 100% !important;
  }

  .w-100 {
    width: 100% !important;
  }

  .tabs-component {
    display: none;
  }

  .buy-desktop {
    display: none;
  }
  .buy-mobile {
    display: inline;
  }

  .go-buy {
    text-align: center !important;
    margin-top: 30px;
    width: 100% !important;
  }
}
</style>
